export enum AppGroupTypes {
    StandardContainment = 1,
    PowerApps = 2,
    Custom = 4,
    Private = 8,
    Restricted = 16,
    AllowList = 32,
    Prohibited = 64
}